import OpenTaskConfirmation from "./OpenTaskConfirmation";
import CloseTaskConfirmation from "./CloseTaskConfirmation";
import ToBeChargedConfirm from "./ToBeChargedConfirm";
import ReopenTaskConfirmation from "./ReopenTaskConfirmation";
import ChangeRepoConfirmation from "./ChangeRepoConfirmation";

const Dialogs = {
    OpenTaskConfirmation,
    CloseTaskConfirmation,
    ToBeChargedConfirm,
    ReopenTaskConfirmation,
    ChangeRepoConfirmation
}
export default Dialogs;